<template>
  <div class="s-aside" :class="[isOpenFilters ? 'is-open' : null]">
    <div class="s-aside-wrapper">
      <button type="button" class="color-link s-aside-close" @click="onToggleFilters">
        <i class="ico ico-cross"></i>
        <span class="hide-access">{{ Translator('global.close') }}</span>
      </button>
      <perfect-scrollbar>
        <div class="s-aside-container">
          <div class="checkbox">
            <label>
              <input type="checkbox" v-model="onlyHasImage" @change="onChangeNeedImage">
              {{ Translator('front.search.image_only') }}
            </label>
          </div>
          <Treeview v-if="facets && facets.length > 0" :items="facets"
            :selected="selectedFacets"
            :opened="openedFacets"
            :displayedMore="displayedMore"
            v-on:open="onToggleOpen"
            v-on:select="onSelect" />
          <div class="most-view" v-if="isShowMostViews && mostViews.length > 0">
            <h2 class="most-view-title">{{ Translator('front.search.most_views') }}</h2>
            <ul class="most-view-list">
              <li class="most-view-element" v-for="notice in mostViews" :key="notice.id">
                <a :href="notice.url" class="most-view-link">
                  <div class="color-image-background most-view-image">
                    <img :src="notice.images.small && notice.images.small" v-if="notice.images && notice.images.small" alt="">
                    <div class="most-view-image-empty" v-else>
                      <span class="sprite -empty-image">
                        <svg viewBox="0 0 1 1" role="img" aria-hidden="true"><use xlink:href="#empty-image"></use></svg>
                      </span>
                    </div>
                  </div>
                  <p class="most-view-name">{{ notice.titles.title }}</p>
                </a>
              </li>
            </ul>
          </div>

        </div>
      </perfect-scrollbar>
    </div>
  </div>
</template>
<style scoped lang="scss">
  .viewer-element {
    .s-aside-button {
      position: absolute;
      top: 0;
      right: rem(-100);
    }
    .s-aside-close {
      position: absolute;
      top: rem(10);
      right: rem(10);
      width: rem(30);
      height: rem(30);
      line-height: rem(30);
      font-size: rem(20);
      cursor: pointer;
      text-align: center;
      z-index: 2;
      @include desktop {
        display: none;
      }
    }
    .v-treeview {
      margin-bottom: rem(40);
    }
    .s-aside {
      @include tablet-max {
        z-index: 1010;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        transform: translateX(-100%);
        transition: transform .2s;
        width: 100%;
        max-width: rem(400);
        .ps {
          height: 100%;
        }
      }
      @include desktop {
        flex-shrink: 0;
        width: rem(250);
        margin-right: rem(30);
      }
      @include desktop-xl {
        margin-right: rem(60);
      }
      &.is-open {
        transform: translateX(0);
      }
    }
    .s-aside-wrapper {
      position: relative;
      height: 100%;
    }
    .s-aside-container {
      @include tablet-max {
        padding: rem(20);
      }
    }

    .most-view {
      .most-view-title {
        font-weight: bold;
        margin-bottom: rem(10);
      }
      .most-view-list {
        @include resetList;
      }
      .most-view-element {
        margin-bottom: rem(5);
      }
      .most-view-link {
        padding: rem(5) 0;
        display: flex;
        text-decoration: none;
        align-items: center;
      }
      .most-view-image {
        position: relative;
        flex-shrink: 0;
        width: rem(48);
        height: rem(48);
        margin-right: rem(10);
        padding: 3%;
        text-align: center;
        img {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          box-shadow: 0 rem(3) rem(6) rgba($black, .08);
        }
      }
      .most-view-name {
        font-size: .8em;
      }
    }
  }
</style>
<script>
import Treeview from '@/front/components/NewTreeview';
import FacetsService from '@/front/services/facets';
import SearchService from '@/front/services/search';
import NoticesService from '@/front/services/notices';
import ConfigService from '@/front/services/config';

export default {
  name: 'Aside',
  data: () => ({
    isOpen: false,
    isOpenFilters: false,
    onlyHasImage: null,
    isShowMostViews: ConfigService.get('showMostViewsNotices') && !ConfigService.get('isCollectionView'),
    mostViews: [],

    facets: [],
    displayedMore: [],
    selectedFacets: [],
    openedFacets: []
  }),
  components: {
    Treeview,
  },
  props: [],
  created() {
    SearchService.on('is-ready', this._onReady);
    SearchService.on('update-params', this._onUpdateSearch);
    SearchService.on('filters-is-show', this._onToggleFilters);
    FacetsService.on('updated', this._onUpdateFacets);
  },

  mounted() {
    this.onlyHasImage = ConfigService.get('onlyHasImage');
    if(this.isShowMostViews) {
      NoticesService.getMostViews().then(res => {
        this.mostViews = res.data['hydra:member'];
      });
    }
    FacetsService.loadedFacets = SearchService.openedFacets.map( facet => facet.id);
  },

  beforeDestroy() {
    SearchService.off('is-ready', this._onReady);
    SearchService.off('update-params', this._onUpdateSearch);
    SearchService.off('filters-is-show', this._onToggleFilters);
    FacetsService.off('updated', this._onUpdateFacets);
    if(this._ps) this._ps.destroy();
  },
  methods: {
    onToggleOpen(pEvt) {
      SearchService.openedFacets = this.openedFacets;
      const isLoaded = FacetsService.loadedFacets.includes(pEvt.item.id)
      if(pEvt.open && !isLoaded) {
        FacetsService.loadedFacets.push(pEvt.item.id)
        FacetsService.filter( pEvt.item.id ).then( res => {
          pEvt.item.children = res.data.data;
          pEvt.item.facetCount = res.data.facetCount;
        })
      }
    },

    onSelect() {
      SearchService.page_silence = 1;
      SearchService.selectedFacets = this.selectedFacets;
    },

    onToggleFilters() {
      SearchService.filtersIsShow = !this.isOpenFilters;
    },

    onChangeNeedImage(pEvt) {
      SearchService.page_silence = 1;
      SearchService.onlyHasImage = pEvt.target.checked ? true : null;
    },

    _onReady() {
      this.fetchTree();
    },

    _onToggleFilters(open) {
      this.isOpenFilters = open;
    },

    _onUpdateSearch() {
      this.fetchTree();
    },

    _onUpdateFacets(datas) {
      this.facets = datas;
      this.selectedFacets = [...SearchService.selectedFacets];
      this.openedFacets = [...SearchService.openedFacets];
    },

    async fetchTree() {
      return FacetsService.getTree().catch( console.error )
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    }
  }
}
</script>
